import SeeMoreCard from './SeeMoreCard';

export default SeeMoreCard;